import { __exports as _ } from "./index164.js";
(function(E) {
  Object.defineProperty(E, "__esModule", { value: !0 }), E.CARRIAGE_RETURN_PLACEHOLDER_REGEX = E.CARRIAGE_RETURN_PLACEHOLDER = E.CARRIAGE_RETURN_REGEX = E.CARRIAGE_RETURN = E.CASE_SENSITIVE_TAG_NAMES_MAP = E.CASE_SENSITIVE_TAG_NAMES = void 0, E.CASE_SENSITIVE_TAG_NAMES = [
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "linearGradient",
    "radialGradient",
    "textPath"
  ], E.CASE_SENSITIVE_TAG_NAMES_MAP = E.CASE_SENSITIVE_TAG_NAMES.reduce(function(R, e) {
    return R[e.toLowerCase()] = e, R;
  }, {}), E.CARRIAGE_RETURN = "\r", E.CARRIAGE_RETURN_REGEX = new RegExp(E.CARRIAGE_RETURN, "g"), E.CARRIAGE_RETURN_PLACEHOLDER = "__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_".concat(Date.now().toString(), "__"), E.CARRIAGE_RETURN_PLACEHOLDER_REGEX = new RegExp(E.CARRIAGE_RETURN_PLACEHOLDER, "g");
})(_);
